import { PayloadAction } from 'typesafe-actions';
import { ConsolidatedTransactionDetailsProviderState, ConsolidatedTransactionDetailsActionTypes } from './types';

const ConsolidatedTransactionDetailsReducer = (
  state: ConsolidatedTransactionDetailsProviderState,
  action: PayloadAction<ConsolidatedTransactionDetailsActionTypes, any>,
): ConsolidatedTransactionDetailsProviderState => {
  switch (action.type) {
    case ConsolidatedTransactionDetailsActionTypes.setSelectedConsolidatedTransaction:
      return {
        ...state,
        selectedConsolidatedTransaction: action.payload,
      };
    default: {
      return state;
    }
  }
};

export { ConsolidatedTransactionDetailsReducer };
